<template lang="pug">
  div
    i.fa.fa-arrows
    span  {{banner.title}}
</template>

<script>
export default {
  name: 'BannerSortOrderNameplate',
  props: {
    banner: {
      type: Object,
      default: () => {}
    }
  }
}
</script>
